import {
  MonthlySummaryAction,
  LOAD_REPORT_DATA,
  LOAD_REPORT_DATA_FAIL,
  LOAD_REPORT_DATA_SUCCESS,
} from "./actionTypes";

interface MonthlySummaryState {
  data?: any; // @TODO
  site: string;
  loading: boolean;
  loaded: boolean;
  error?: string;
}

const initialState: MonthlySummaryState = {
  data: undefined,
  error: undefined,
  site: "",
  loading: false,
  loaded: false,
};

export function reducer(
  state = initialState,
  action: MonthlySummaryAction
): MonthlySummaryState {
  switch (action.type) {
    case LOAD_REPORT_DATA:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case LOAD_REPORT_DATA_SUCCESS:
      return {
        ...state,
        data: action.result.data,
        site: action.result.site,
        loading: false,
        loaded: true,
      };
    case LOAD_REPORT_DATA_FAIL:
      // TODO: Add proper error handling
      return {
        ...state,
        data: state.data,
        loading: false,
        loaded: false,
        error: "Something went wrong",
      };
    default:
      return state;
  }
}
